import { useEffect } from "react";
import { registrarSnapshot } from "../utils/painelRegistry";

/**
 * Hook que publica o snapshot de exportação do painel atual no registry
 * global usado pelo agendador.
 *
 *   useExportSnapshot("marcenaria", {
 *     titulo,
 *     resumo,
 *     secoes,
 *     visual,     // mesmo formato consumido por <BotaoExportacao>
 *   }, pageRef);
 *
 * O snapshot é atualizado sempre que `resumo` ou `secoes` mudam. Ele
 * PERSISTE em memória mesmo após a página desmontar, para que o agendador
 * possa exportar PDF/Excel/CSV de painéis que o usuário visitou em
 * qualquer momento da sessão.
 *
 * Para PNG/JPG, o `getVisualRoot` retorna `pageRef.current` — quando a
 * página desmonta, vira `null`, sinalizando para o agendador usar o
 * iframe oculto para re-renderizar e capturar.
 */
export function useExportSnapshot(painelId, payload, pageRef) {
  useEffect(() => {
    if (!painelId || !payload) return;
    // `pronto: false` = página ainda carregando (1º render com dados vazios).
    // Não registra: o agendador via iframe aceitava esse snapshot vazio e o
    // Excel/CSV agendado saía só com o Resumo zerado (race de carga).
    if (payload.pronto === false) return;
    registrarSnapshot(painelId, payload, {
      getVisualRoot: pageRef ? () => pageRef.current : null,
    });
    // SEM cleanup — snapshot persiste após desmontar.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [painelId, payload?.resumo, payload?.secoes, payload?.titulo, payload?.pronto]);
}
